import React, { FC } from "react";
import CompanyContentTitle from "../CompanyContentTitle";
import CompanyMediaContent from "../../CompanyMediaContent/CompanyMediaContent";
import "../styles.scss";
// import CustomModal from "../../../CustomModalComponent/CustomModal";
// import AddTeamModalBody from "../../AddTeamModalBody/AddTeamModalBody";
// import { CustomModalProvider } from "../../../Contexts/CustomModalContext";

interface IProps {
  company: { team: []; name: string; company_id: string };
}

const MediaSection: FC<IProps> = (props: IProps) => {
  const { company } = props;
  return (
    <>
      {/* <CustomModalProvider> */}
      <CompanyContentTitle title="Media" />

      <div className="ps-company-content__container">
        <CompanyMediaContent company={company} />
      </div>
      {/* <CustomModal>
        <AddTeamModalBody />
      </CustomModal> */}
      {/* </CustomModalProvider> */}
    </>
  );
};

export default MediaSection;
